export const WELCOME_PAGE_URL = "/";
export const AUTH_PAGE_URL = "/auth";
export const DASHBOARD_PAGE_URL = "/dashboard";
export const CHECKOUT_PAGE_URL = "/checkout";
export const RESTAURANT_PAGE_URL = "/restaurant";
export const SETTING_PAGE_URL = "/settings";
export const CAFE_PASS_URL = "/cafepass";
export const PRE_BOOK_URL = "/dashboard/prebook";



// WEBPACK FOOTER //
// ./src/utils/Route.js